import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Radio } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("failed"); return; }
      } catch { /* keep polling */ }
      if (tries++ < 8) setTimeout(poll, 2000); else setState("pending");
    };
    poll();
  }, [sessionId]);

  const map = {
    checking: { icon: Loader2, spin: true, t: "Confirming payment…", d: "Hang tight while we verify with Stripe." },
    paid: { icon: CheckCircle2, t: "Subscription active", d: "Your workspace is provisioned. Welcome to full command." },
    pending: { icon: Loader2, spin: true, t: "Still processing", d: "This can take a moment. Refresh shortly." },
    failed: { icon: XCircle, t: "Payment failed", d: "No charge was completed. You can try again from Billing." },
    error: { icon: XCircle, t: "Missing session", d: "We couldn't find that checkout session." },
  };
  const s = map[state];
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0F17] px-6">
      <div className="card-tac max-w-md p-10 text-center" data-testid="payment-result-card">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-amber-500/10 text-amber-400">
          <s.icon className={`h-7 w-7 ${s.spin ? "animate-spin" : ""}`} />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold text-white">{s.t}</h1>
        <p className="mt-2 text-slate-400">{s.d}</p>
        <Link to="/billing" className="btn-amber mt-8 inline-block rounded-full px-6 py-3 text-sm" data-testid="payment-result-continue">Go to Billing</Link>
      </div>
    </div>
  );
}
